import styled, { AnyStyledComponent } from 'styled-components'
import { desktopBreakpoint, tabletBreakpoint, Markdown } from 'react-components'

import DownArrowImage from '../../assets/images/down-arrow.svg'
import UpArrowImage from '../../assets/images/up-arrow.svg'

export const CellContainer = styled.div`
    width: inherit;
    margin: 1.25rem 0.625rem;
    background-color: ${props => props.theme.colors.white};
    border-radius: 6px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.15);

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        /* For tablets: */
        margin: 1.25rem;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        /* For desktops: */
        margin: 1.25rem auto;
        max-width: 1110px;
    }
`

export const TitleContainer = styled.div`
    width: inherit;
    padding: 1.25rem 1rem 1.25rem 1.25rem;
    margin: 0rem;
    display: ${props => props.theme.style.display.flex};
    flex-wrap: ${props => props.theme.style.flexWrap.wrap};
    flex-direction: ${props => props.theme.style.flexDirection.row};
    cursor: pointer;
`
export const TitleContent = styled.h4`
    width: 78%;
    font-family: ${props => props.theme.typography.font.family.yummo};
    font-size: ${props => props.theme.typography.font.size.large};
    font-weight: normal;
    line-height: normal;
    margin: 0 auto 0 0;
    color: ${props => props.theme.colors.tfwBlack87};

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        /* For tablets: */
        line-height: 1.08;
        font-size: ${props => props.theme.typography.font.size.xLarge};
    }
`

export const TitleIconUp = styled(UpArrowImage as AnyStyledComponent)`
    width: 1.25rem;
    height: 1.25rem;
    font-weight: normal;
    line-height: 0.76;
    letter-spacing: normal;
    margin: 0 0 0 auto;
    color: ${props => props.theme.colors.tfwBlack87};
    transition: transform 0.25s ease;
`

export const TitleIconDown = styled(DownArrowImage as AnyStyledComponent)`
    width: 1.25rem;
    height: 1.25rem;
    font-weight: normal;
    line-height: 0.76;
    letter-spacing: normal;
    margin: 0 0 0 auto;
    color: ${props => props.theme.colors.tfwBlack87};
    transition: transform 0.25s ease;
`

export const DescriptionContainer = styled(Markdown as AnyStyledComponent)`
    width: inherit;
    height: inherit;
    margin: 0 1.25rem;
    padding-bottom: 1.25rem;
    font-family: ${props => props.theme.typography.font.family.lato};
    font-size: ${props => props.theme.typography.font.size.medium};
    line-height: 1.38;
    font-weight: 300;
    color: ${props => props.theme.colors.tfwBlack87};
    & > p {
        margin: 0;
    }
    & > p > a {
        color: ${props => props.theme.colors.tfwBlack87};
        font-weight: normal;
    }
`
